<template>
  <v-footer padless class="footer--fixed">
    <v-container class="d-flex">
      <div class="footer__stepper-buttons">
        <PrevButton
          @click="handlePrevBtnClick"
          :disabled="ctaBtn.loading"
        />

        <CtaButton
          v-if="shouldShowCTA && ctaBtn.show"
          :type="ctaBtn.type"
          :disabled="ctaBtn.disabled"
          :loading="ctaBtn.loading"
          @click="handleCtaBtnClick"
        />

        <ManualSignButton
          v-if="manualSignBtn.show"
          :disabled="manualSignBtn.disabled"
          @click="handleManualSignBtnClick"
        />
      </div>
    </v-container>
  </v-footer>
</template>

<script>
import PrevButton from '@/components/stepper-footer/PrevButton'
import CtaButton from '@/components/stepper-footer/CtaButton'
import ManualSignButton from '@/components/stepper-footer/ManualSignButton'
import { GET_OFFER_ITEM } from '@/store/modules/offer/getters'
import { mapGetters } from 'vuex'

export default {
  name: 'StepperFooter',
  components: {
    PrevButton,
    CtaButton,
    ManualSignButton,
  },

  computed: {
    ...mapGetters('offer', [GET_OFFER_ITEM]),

    shouldShowCTA() {
      const desc = this[GET_OFFER_ITEM]('rateModelDesc')        
      if (this.ctaBtn.type === 'sign' && desc?.contractModel === 'PDF_VENTA_DIRECTA_2025_PT') {
        return false
      }
      return true
    },
  },

  props: {
    ctaBtn: {
      type: Object,
      default: () => ({
        type: 'continue',
        show: true,
        loading: false,
        disabled: false,
      }),
    },
    manualSignBtn: {
      type: Object,
      default: () => ({
        show: false,
        disabled: false,
      }),
    },
  },

  methods: {
    handlePrevBtnClick() {
      this.$emit('onClickPrevBtn')
    },
    handleCtaBtnClick() {
      this.$emit('onClickCtaBtn')
    },
    handleManualSignBtnClick() {
      this.$emit('onClickManualSignBtn')
    },
  },
}
</script>

<style scoped lang="scss">
.footer {
  &--fixed {
    position: fixed;
    bottom: 0;
    z-index: 9;
    width: 100%;
  }
  &__stepper-buttons {
    margin-left: auto;

    & button {
      margin-right: 1rem;
    }
    & button:last-child {
      margin-right: 0;
    }
  }
}
</style>
